import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainPage from './pages/MainPage';
import AboutPage from './pages/AboutPage';
import HistoryPage from './pages/HistoryPage';
import EventPage from './pages/EventPage';
import StoryPage from './pages/StoryPage';
import ScrollToTop from './utils/ScrollTop';
import Event2507 from './pages/event/Event2507'; 
// import Event2504 from './pages/event/Event2504'; 
import Test from './pages/test/TestGA';
import Event2512 from './pages/event/Event2512';


function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<MainPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/event" element={<Event2507 />} />
          <Route path="/event_2504" element={<EventPage />} />
          <Route path="/event_2507" element={<Event2507 />} />
          <Route path="/event_2512" element={<Event2512 />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/test" element={<Test />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
